namespace Gordic.Adm.WebControls {

    const { gcontent } = Decorators;

    @gcontent
    export class GAdmDashboard extends GContentBase {

        private countAdminConsentBeforeExpire: number;
        private adminConsentBeforeExpire: Gordic.AdmIsl.Interface.GAdmOAuthTokenListDto[];
        private moduleInfoItems: any;
        private NazevRef: string;
        private NazevFun: string;
        private DatLoginTxt: string;
        private intervalId: number;
        private develop: boolean;
        private dataView: Gordic.Data.View;


        public onContentReady() {
            if (this.develop == true) {
                Gordic.Async.GTaskManager.on<Gordic.Async.IGTaskProgress, string>("done", "Gordic.General.ApplicationServer.GOauthNotifyAsyncTask", function (result) {
                    var res = result.result;
                    $.content().notification("add", { title: "ÓhAut redy", content: res }, true);
                    this.clean();
                });
            }
            this.loadModuleInfo();
            if (this.develop == true) {
                this.createStatistics();
                this.createDashboardPanel();
            }
        }

        public onClose() {
            clearInterval(this.intervalId);
        }

        /** načíst informace o modulu */
        private loadModuleInfo() {

            var i = 0;
            var result: any[] = [];
            var secondaryText = this.NazevRef + " | " + this.NazevFun + " | " + "jres:32000141" + ": " + this.DatLoginTxt; //RC 32000141 : Poslední přihlášení

            result.push(new GObservableObject({
                name: "kpiLastUsed" + "_" + i,
                image: "<img class='g-app-launcher__item' style='width:48px;height:48px;' alt='app:GWAADM05.svg' src='gin/gz.ashx?r=app&amp;f=GWAADM05.svg'>",
                primaryText: "jres:32000138", //RC 32000138 : Administrace
                secondaryText: secondaryText,
            }));

            this.moduleInfoItems = new Gordic.Data.View([{
                id: "moduleInfo",
                //title: "", //RC 32000140 : Modul
                zone: 0,
                mode: "vertical",
                itemTemplate: Gordic.Prefabs.Panels.kpiImageTwoRowsTextTemplate().itemTemplate,
                defaultSelected: false,
                data: new Gordic.Data.View(result)
            }], { key: ["id"] });

            $("<div>").appendTo(this.element).gdashboardpanel({
                data: this.moduleInfoItems,
                layout: "horizontal",
                title: "",
                sortable: true
            });
        }

        /** Stav vnitřních proměnných */
        private createStatistics() {
            var gtabCnt = $("<div>").appendTo(this.element);
            this.intervalId = setInterval(() => {
                this.setDataToPanel(gtabCnt);
            }, 10000)
            this.setDataToPanel(gtabCnt);
        }

        private setDataToPanel(cnt: JQuery<HTMLElement>) {
            this.beginOperation();
            this.isl.AdmDbPool.list().getData().done((data) => {
                cnt.empty();
                var dataArray = new Array();
                dataArray.push({
                    value: data[0]["idle"],
                    primaryText: "jres:33000373", //RC 33000373 : Volné konekty
                    secondaryText: "jres:33000374", //RC 33000374 : AKTUÁLNĚ
                    meaning: "info"
                })
                dataArray.push({
                    value: data[0]["maxIdle"],
                    primaryText: "jres:33000373",
                    secondaryText: "jres:33000376", //RC 33000376 : MAXIMUM
                    meaning: "error"
                })
                dataArray.push({
                    value: data[0]["running"],
                    primaryText: "jres:33000375", //RC 33000375 : Použité konekty
                    secondaryText: "jres:33000374",
                    meaning: "info"
                })
                dataArray.push({
                    value: data[0]["maxRunning"],
                    primaryText: "jres:33000375",
                    secondaryText: "jres:33000376",
                    meaning: "error"
                })
                var view = new Gordic.Data.View(dataArray);
                var dataDasboard: any[] = [];
                dataDasboard.push({
                    title: "jres:33000377", //RC 33001050 : Administrátorské souhlasy před expirací ({0})
                    itemTemplate: Gordic.Prefabs.Panels.kpiValueTwoRowsTextTemplate().itemTemplate,
                    defaultSelected: false,
                    data: dataArray
                })
                $("<div>").appendTo(cnt).gdashboardpanel({
                    data: dataDasboard
                })
            }).always(() => { this.endOperation() })
        }

        private createDashboardPanel() {
            let data: any[] = [];
            let adminConsents = this.getStatsExpireAdminConsent();
            if (adminConsents.length > 0)
                data.push({
                    title: "jres:33001050".format(this.countAdminConsentBeforeExpire), //RC 33001050 : Administrátorské souhlasy před expirací ({0})
                    itemTemplate: Gordic.Prefabs.Panels.kpiValueTwoRowsTextTemplate().itemTemplate,
                    defaultSelected: false,
                    data: adminConsents
                })


            $("<div>").appendTo(this.element).gdashboardpanel({
                data: data
            })
        }

        private getStatsExpireAdminConsent(): any[] {
            var data: any[] = [];
            this.adminConsentBeforeExpire.forEach((item) => {
                if (item.dat_exp) {
                    let exp = Math.floor((Math.floor(new Date(item.dat_exp as any).getTime() / 1000) - Math.floor(new Date().getTime() / 1000)) / (3600 * 24));
                    let expirovano = (exp <= 0)
                    data.push({
                        value: expirovano ? -exp : exp,
                        primaryText: expirovano ? `jres:33001048` : `jres:33001049`, //RC 33001049 : Počet dní do expirace
                        secondaryText: "jres:33001047".format(item.ixs_oap_txt ?? "", Gordic.Templates.Formatters.date(item.dat_exp, "datetime"), item.oauth_service_txt ?? ""), //RC 33001047 : <b>Profil:</b> {0} | <b>Dat. exp.:</b> {1} | <b>Služba:</b> {2}
                        meaning: expirovano ? "negative" : "info"
                    })
                }
            })
            return data;
        }
    }

}